/* Substrate Wizard — single-step, auto-advance, single-column
 * - Steps + animals + catalog come from /pages/substrate-wizard-data?view=json
 * - Animals include age_substrates for age-specific substrate recommendations
 * - "package" step rendered as variant cards (image + name + price)
 */

(function () {

  console.log("live")

  const root = document.querySelector('[data-swz]');
  if (!root) {
    console.log('[SWZ] root [data-swz] not found, aborting');
    return;
  }

  const container   = root.querySelector('[data-swz-container]');
  const pageLoader  = root.querySelector('[data-swz-page-loader]');
  const stepsMount  = root.querySelector('[data-swz-steps]');
  const productSlot = root.querySelector('[data-swz-productslot]');
  const addForm     = root.querySelector('[data-swz-addform]');
  const qtyInput    = root.querySelector('[data-swz-qty]');
  const qtyMinus    = root.querySelector('[data-swz-qty-minus]');
  const qtyPlus     = root.querySelector('[data-swz-qty-plus]');
  const addBtn      = root.querySelector('[data-swz-addbtn]');
  const noteEl      = root.querySelector('[data-swz-note]');
  const addWrap     = root.querySelector('[data-swz-addwrap]');

  // Initial state: hide wizard, show page loader
  if (container) container.style.display = 'none';
  if (pageLoader) pageLoader.style.display = 'flex';

  if (!stepsMount) {
    console.log('[SWZ] stepsMount [data-swz-steps] not found, aborting');
    return;
  }

  // ---------- debug helper

  const DEBUG = false;
  function dbg(...args) {
    if (!DEBUG || !window.console) return;
    console.log('[SWZ]', ...args);
  }

  // ---------- GA4 tracking 

  function track(eventName, params = {}) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, { ...params });
    } else {
      console.log('[SWZ TRACK]', eventName, params);
    }
  }



// ---------- Deepest-step (journey depth) tracking

function makeJourneyId() {
  try {
    return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  } catch (e) {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}

const SWZ_JOURNEY_ID = makeJourneyId();
let SWZ_MAX_STEP_REACHED = -1;
let SWZ_MAX_STEP_KEY = null;

function trackDepthProgress(stepIndex, stepKey) {
  if (!Number.isFinite(stepIndex)) return;
  //if (stepKey === "package") return;
  if (stepIndex <= SWZ_MAX_STEP_REACHED) return;

  SWZ_MAX_STEP_REACHED = stepIndex;
  SWZ_MAX_STEP_KEY = stepKey || null;

  track("swz_depth_progress", {
    journey_id: SWZ_JOURNEY_ID,
    max_step_reached: SWZ_MAX_STEP_REACHED,
    max_step_key: SWZ_MAX_STEP_KEY,
    page_path: location.pathname
  });
}


  dbg('init: starting');



    // ---------- Klaviyo animals tracking helpers

    function swzAddViewedAnimalTitle(title) {
      const key = "animals";
      const existing = JSON.parse(localStorage.getItem(key) || "[]");

      if (title && !existing.includes(title)) {
        existing.push(title);
        localStorage.setItem(key, JSON.stringify(existing));
      }

      return existing;
    }

    function swzIdentifyAnimalsInKlaviyo(animalsArr) {
      const valueToSend = animalsArr.length === 1 ? animalsArr[0] : animalsArr;

      console.log("[SWZ] animals list:", valueToSend);

      function sendWhenReady() {
        if (window._learnq && typeof window._learnq.push === "function") {
          window._learnq.push(["identify", { animals: valueToSend }]);
          console.log("[SWZ] identify sent to Klaviyo", valueToSend);
        } else {
          console.log("[SWZ] …waiting for Klaviyo to load");
          setTimeout(sendWhenReady, 200);
        }
      }

      sendWhenReady();
    }

    function swzTrackAnimalSelection(animalTitle) {
      const animals = swzAddViewedAnimalTitle((animalTitle || "").trim());
      swzIdentifyAnimalsInKlaviyo(animals);
    }




  // ---------- basic helpers

  // Load JSON from <script id="substrate-wizard-data"> or its data-src URL
  async function loadAllJSONPages() {
    const tag = document.getElementById('substrate-wizard-data');
    if (!tag) throw new Error('substrate-wizard-data script tag not found');

    const baseSrc = tag.getAttribute('data-src');
    if (!baseSrc) throw new Error('substrate-wizard-data data-src missing');

    // page 1
    const firstRes = await fetch(baseSrc, { credentials: 'same-origin' });
    if (!firstRes.ok) throw new Error('Failed to fetch wizard JSON (page 1)');
    const first = await firstRes.json();

    const allAnimals = Array.isArray(first.animals) ? first.animals.slice() : [];
    const pag = first.pagination || {};
    const totalPages = pag.total_pages || 1;

    if (totalPages > 1) {
      const urlObj = new URL(baseSrc, window.location.origin);
      const promises = [];

      for (let p = 2; p <= totalPages; p++) {
        const u = new URL(urlObj);
        u.searchParams.set('page', String(p));
        promises.push(
          fetch(u.toString(), { credentials: 'same-origin' }).then(r => r.json())
        );
      }

      const pages = await Promise.all(promises);
      pages.forEach(pg => {
        if (Array.isArray(pg.animals)) {
          allAnimals.push(...pg.animals);
        }
      });
    }

    first.animals = allAnimals;
    return first;
  }

  const qa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const el = (tag, attrs = {}, html = '') => {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (v == null) return;
      if (k === 'class') n.className = v;
      else if (k === 'dataset') Object.entries(v).forEach(([dk, dv]) => (n.dataset[dk] = dv));
      else if (k === 'hidden') {
        if (v) n.setAttribute('hidden', '');
        else n.removeAttribute('hidden');
      } else {
        n.setAttribute(k, v);
      }
    });
    if (html) n.innerHTML = html;
    return n;
  };

  const toCents = (val) => {
    if (val == null || val === '') return 0;
    if (typeof val === 'number') return Number.isInteger(val) ? val : Math.round(val * 100);
    const num = parseFloat(String(val).replace(/[^0-9.]/g, ''));
    return Number.isFinite(num) ? Math.round(num * 100) : 0;
  };

  const fmtMoney = (val, currency = 'USD') =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(toCents(val) / 100);

  function normalizeSrc(src) {
    if (!src) return null;
    let out = src;
    if (typeof out === 'object' && out.src) out = out.src;
    if (typeof out !== 'string') return null;
    return out.startsWith('//') ? `https:${out}` : out;
  }





// ---------- Step 2 helper message + SWZ Contact Modal (self-contained)


function swzShowContactSuccess() {
  const modal = ensureSwzContactModal();
  const panel = modal.querySelector('.swz-modal__panel');

  panel.innerHTML = `
    <button class="swz-modal__close" type="button" data-swz-close>✕</button>
    <h3 class="swz-modal__title" style="font-color: #43200a;">Message sent</h3>
    <p>Thanks for contacting us. We'll get back to you as soon as possible.</p>
  `;

  modal.removeAttribute('hidden');
  document.body.classList.add('swz-modal-open');
}


function ensureStep2HelpMessage(bodyEl) {
  if (!bodyEl) return;

  // Only create once per step body
  let wrap = bodyEl.querySelector('[data-swz-step2-help]');
  if (wrap) return;

  wrap = el('div', { class: 'swz-stephelp', dataset: { swzStep2Help: '' } }, `
    <button type="button" class="swz-stephelp__link" data-swz-open-contact>
      Don’t see your animal? <span>Let us know</span>
    </button
  `);

  bodyEl.appendChild(wrap);
}

let swzContactModal = null;

function ensureSwzContactModal() {
  if (swzContactModal) return swzContactModal;

  swzContactModal = el('div', {
    class: 'swz-modal',
    dataset: { swzContactModal: '' },
    hidden: true
  }, `
    <div class="swz-modal__overlay" data-swz-close></div>

    <div class="swz-modal__panel" role="dialog" aria-modal="true" aria-label="Contact us">
      <button class="swz-modal__close" type="button" aria-label="Close" data-swz-close>✕</button>

      <h3 class="swz-modal__title">Don’t see your animal?</h3>
      <p class="swz-modal__sub">Tell us what you're looking for and we’ll help.</p>

      <form class="swz-modal__form" method="post" action="/contact#contact_form" accept-charset="UTF-8">
        <input type="hidden" name="form_type" value="contact">
        <input type="hidden" name="utf8" value="✓">

        <input class="swz-input" type="text" name="contact[name]" placeholder="Your name" required>
        <input class="swz-input" type="email" name="contact[email]" placeholder="Email address" required>

        <textarea class="swz-input" name="contact[body]" rows="4"
          placeholder="What animal are you looking for?"
          required></textarea>

        <button class="swz-btn swz-btn--primary button button--primary" type="submit">
          Send message
        </button>
      </form>
    </div>
  `);

  document.body.appendChild(swzContactModal);
  return swzContactModal;
}

function openSwzContactModal() {
  const modal = ensureSwzContactModal();
  modal.removeAttribute('hidden');
  document.body.classList.add('swz-modal-open');
}

function closeSwzContactModal() {
  if (!swzContactModal) return;
  swzContactModal.setAttribute('hidden', '');
  document.body.classList.remove('swz-modal-open');
}

  function showInlineError(msg) {
    const sec = stepsMount.querySelector(`.swz-step[data-step-index="${state.currentIndex}"]`);
    const body = sec?.querySelector('.swz-step__body');
    if (!body) return;
    let err = body.querySelector('[data-swz-error]');
    if (!err) {
      err = el('div', { class: 'swz-error', dataset: { swzError: '' } });
      body.appendChild(err);
    }
    err.textContent = msg || 'Something went wrong. Please try again.';
  }

    function setAddWrapVisible(on) {
      // track transition (hidden -> visible)
      const wasVisible = !!state.atcVisible;

      if (!addWrap) return;

      if (on) {
        addWrap.removeAttribute('hidden');
        addWrap.classList.add('is-visible');

        state.atcVisible = true;

        setTimeout(() => {
          scrollIntoViewIfNeeded(addWrap);
        }, 0);
      } else {
        addWrap.setAttribute('hidden', '');
        addWrap.classList.remove('is-visible');

        state.atcVisible = false;
      }

      // Return whether we just transitioned to visible
      return !wasVisible && !!state.atcVisible;
    }




    function scrollIntoViewIfNeeded(el) {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    // If it's above the viewport or below it, scroll
    if (rect.top < 0 || rect.bottom > vh) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }


  // helper: get quarts from catalog for a given selection
  function getQuarts(prodKey, fmtKey, pkgName) {
    try {
      const prod = state.catalog.products[prodKey];
      if (!prod || !prod.formats) return null;
      const fmt = prod.formats[fmtKey];
      if (!fmt || !fmt.packages) return null;
      const pkg = fmt.packages[pkgName];
      if (!pkg) return null;
      const q = Number(pkg.quarts);
      return Number.isFinite(q) && q > 0 ? q : null;
    } catch (e) {
      return null;
    }
  }

  // helper: build "X per quart" label
  function buildPerQuartLabel(priceCents, quarts) {
    if (!priceCents || !quarts) return '';
    const perQuart = (priceCents / 100) / quarts;
    const formatted = fmtMoney(perQuart, state.meta.currency);
    return `${formatted} per quart`;
  }

  

  // ---------- state

  const state = {
    meta: { currency: 'USD', version: '1.0' },
    steps: [],
    taxonomy: {},
    catalog: { products: {} },
    animals: [],
    selections: {},
    currentIndex: 0,
    variantCache: {},
    _skipHash: false,
    wasFormatAutoSkipped: false,
    wasMaturityAutoSkipped: false,
    autoSkipped: {},
    atcVisible: false,
    atcReady: false,
   _navIntent: null
  };


  function clearFromStepIndex(startIdx) {
    for (let i = startIdx; i < state.steps.length; i++) {
      const k = state.steps[i]?.key;
      if (!k) continue;

      delete state.selections[k];

      // IMPORTANT: reset autoskip state for cleared steps
      state.autoSkipped[k] = false;
    }
  }



  function findPrevVisibleIndex(fromIdx) {
  for (let i = fromIdx; i >= 0; i--) {
    const k = state.steps[i]?.key;
    if (!k) continue;
    if (state.autoSkipped && state.autoSkipped[k]) continue; // skip hidden steps
    return i;
  }
  return 0;
}





  function getBreadcrumbItems() {
    const items = [];

    (state.steps || []).forEach((s, i) => {
      const key = s?.key;
      if (!key) return;

      // ✅ Only show crumbs for steps BEFORE the current step
      if (i >= state.currentIndex) return;

      // Skip autoskipped steps
      if (state.autoSkipped && state.autoSkipped[key]) return;

      const value = state.selections[key];
      if (value == null || value === '') return;

      items.push({
        stepIndex: i,
        stepKey: key,
        stepLabel: s.label || key,
        value: String(value)
      });
    });

    return items;
  }




  function renderBreadcrumbs() {
    const mounts = qa('[data-swz-breadcrumbs]', document); // <-- key change
    if (!mounts.length) return;

    const crumbs = getBreadcrumbItems();

    if (!crumbs.length) {
      mounts.forEach(m => (m.innerHTML = ''));
      return;
    }

    const html = crumbs.map((c, idx) => {
      const sep = idx ? `<span class="swz-bc__sep">›</span>` : '';
      return `${sep}
        <button type="button"
          class="swz-bc__crumb"
          data-swz-crumb
          data-step-index="${c.stepIndex}">
          ${c.value}
        </button>`;
    }).join('');

    mounts.forEach(m => (m.innerHTML = html));
  }



  /* ---- global loading overlay (used ONLY when building package step) ---- */

  let globalLoader = null;

  function ensureGlobalLoader() {
    if (globalLoader) return globalLoader;

    // Attach overlay to the steps card so it sits inside the border
    const host = stepsMount.closest('.swz-card') || stepsMount || root;

    globalLoader = el(
      'div',
      {
        class: 'swz-loading-overlay',
        dataset: { swzLoading: '' },
        hidden: true
      },
      '<div class="swz-spinner" aria-hidden="true"></div>'
    );

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }

    host.appendChild(globalLoader);
    return globalLoader;
  }

  function setGlobalLoading(on) {
    const loader = ensureGlobalLoader();
    if (on) {
      loader.removeAttribute('hidden');
    } else {
      loader.setAttribute('hidden', '');
    }
  }

  // ---------- layout: shell + back button

  function buildShell() {
    dbg('buildShell: creating steps', state.steps);
    stepsMount.innerHTML = '';

    state.steps.forEach((s, i) => {
      const isActive = i === state.currentIndex;

      const sec = el('section', {
        class: 'swz-step' + (isActive ? ' is-active' : ''),
        dataset: { stepKey: s.key, stepIndex: String(i) },
        hidden: !isActive,
        'aria-hidden': isActive ? 'false' : 'true'
      });

      const header = el('header', { class: 'swz-step__header' });

        const crumbs = el('nav', {
          class: 'swz-breadcrumbs',
          'data-swz-breadcrumbs': '',
          'aria-label': 'Your choices'
        });

      header.appendChild(crumbs);

      header.appendChild(el('h3', { class: 'swz-step__title' }, s.label || s.key));

      const body = el('div', { class: 'swz-step__body', dataset: { optionsFor: s.key } });
      const controls = el('div', { class: 'swz-controls' });
      const back = el(
        'button',
        { type: 'button', class: 'swz-btn swz-btn--ghost button button--primary', dataset: { action: 'back' } },
        'Back'
      );
      controls.append(back);

      sec.append(header, body, controls);
      stepsMount.appendChild(sec);
    });

    setBackVisibility();
  }

  function setBackVisibility() {
    qa('.swz-step', stepsMount).forEach((sec) => {
      const idx = Number(sec.dataset.stepIndex || 0);
      const back = sec.querySelector('[data-action="back"]');
      if (!back) return;
      if (idx === 0) {
        back.classList.add('is-hidden');
        back.setAttribute('tabindex', '-1');
        back.setAttribute('aria-hidden', 'true');
      } else {
        back.classList.remove('is-hidden');
        back.removeAttribute('tabindex');
        back.removeAttribute('aria-hidden');
      }
    });
  }

  function hasContentSectionFor(stepKey) {
    const exists = !!document.querySelector(`[data-bind-step="${stepKey}"]`);
    dbg('hasContentSectionFor:', stepKey, '→', exists);
    return exists;
  }

  function toggleMainVisibilityFor(stepKey) {
    if (!stepsMount) return;

    const shouldHide = hasContentSectionFor(stepKey);
    dbg('toggleMainVisibilityFor:', stepKey, 'hasContent?', shouldHide);

    stepsMount.style.display = shouldHide ? 'none' : '';
  }


    async function showOnly(index) {
      const intendedIndex = Math.max(0, Math.min(index, state.steps.length - 1));
      state.currentIndex = intendedIndex;

      dbg('showOnly: requested index', index, 'clamped to', state.currentIndex, 'selections', state.selections);

      qa('.swz-step', stepsMount).forEach((sec, i) => {
        const on = i === state.currentIndex;

        if (on) {
          sec.classList.add('is-active');
          sec.removeAttribute('hidden');
          sec.setAttribute('aria-hidden', 'false');
        } else {
          sec.classList.remove('is-active');
          sec.setAttribute('hidden', '');
          sec.setAttribute('aria-hidden', 'true');
        }
      });

      setBackVisibility();

      await buildOptionsForActiveStep();

      // ✅ IMPORTANT: buildOptionsForActiveStep may have auto-advanced by calling showOnly()
      // which changes state.currentIndex. If so, this call is no longer "the active one".
      if (state.currentIndex !== intendedIndex) return;

      const currentStep = state.steps[state.currentIndex];
      const stepKey = currentStep?.key || '';
      dbg('showOnly: after build, effective step', stepKey, 'index', state.currentIndex);

     
        track('swz_step_view', {
          journey_id: state.journey_id,
          step_index: state.currentIndex,
          step_key: stepKey || null,
          selections: { ...state.selections }
        });
      

      trackDepthProgress(state.currentIndex, stepKey);

      toggleMainVisibilityFor(stepKey);
      broadcast();

      const keyForHash = stepKey || '';
      if (!state._skipHash) {
        location.hash = `#step-${state.currentIndex + 1}-${keyForHash}`;
      }
    }



  // ---------- swatch builders

  function buildSwatches(container, values, key) {
    dbg('buildSwatches for', key, 'values:', values);
    container.innerHTML = '';
    const grid = el('div', { class: 'swz-swatchgrid' });
    values.forEach((v) => {
      const btn = el(
        'button',
        { type: 'button', class: 'swz-swatch', dataset: { value: v } },
        `<span class="swz-swatch__label">${v}</span>`
      );
      if (state.selections[key] === v) btn.classList.add('is-selected');
      grid.appendChild(btn);
    });
    container.appendChild(grid);
  }

  // ---------- animals + categories

  const slugify = (s) => (s || '').toString().trim().toLowerCase();

  function animalMatchesCategory(animal, categoryName) {
    if (!animal || !categoryName) return false;
    const target = slugify(categoryName);

    const tags = Array.isArray(animal.tags) ? animal.tags : [];
    if (tags.some((t) => slugify(t) === target)) {
      return true;
    }

    if (animal.category && slugify(animal.category) === target) {
      return true;
    }

    return false;
  }

  function findCategoryByName(selectedCat) {
    if (!selectedCat) return null;
    const target = slugify(selectedCat);
    const cats = state.taxonomy.categories || [];
    const found = cats.find((c) => slugify(c.name || c.label || c.title || c.key) === target) || null;
    return found;
  }

  function getCurrentAnimal() {
    const t = slugify(state.selections.specificAnimal);
    if (!t) return null;
    return state.animals.find((a) => slugify(a.title) === t) || null;
  }

  function buildAnimalCards(container) {
    dbg('buildAnimalCards: starting, total animals', state.animals.length, 'current selections:', state.selections);

    let animals = Array.isArray(state.animals) ? state.animals.slice() : [];

    const selectedCat = state.selections.broadCategory;
    if (selectedCat) {
      const beforeCount = animals.length;
      animals = animals.filter((a) => animalMatchesCategory(a, selectedCat));
      dbg(
        'buildAnimalCards: filtered by category',
        selectedCat,
        'from',
        beforeCount,
        'to',
        animals.length,
        'titles:',
        animals.map((a) => a.title)
      );
    } else {
      dbg('buildAnimalCards: no broadCategory selected, showing all animals');
    }

    animals.sort((a, b) => (a.title || '').localeCompare(b.title || ''));

    container.innerHTML = '';
    const grid = el('div', { class: 'swz-animalgrid' });

    animals.forEach((a) => {
      const img = normalizeSrc(a.image);
      const card = el(
        'button',
        {
          type: 'button',
          class: 'swz-animalcard',
          dataset: { value: a.title }
        },
        `
          ${img ? `<img class="swz-animalcard__img" src="${img}" alt="${a.title}">` : ''}
          <div class="swz-animalcard__title">${a.title}</div>
        `
      );
      grid.appendChild(card);
    });

    dbg('buildAnimalCards: final card count', animals.length);
    container.appendChild(grid);
  }

  // ---------- substrate choice from age_substrates

  function productStringToCatalogKey(str) {
    if (!str) return null;
    const s = str.toString().toLowerCase();
    const catalogKeys = Object.keys(state.catalog.products || {});

    for (const key of catalogKeys) {
      if (key.toLowerCase() === s) return key;
    }

    const patterns = [
      { key: 'ReptiChip',    match: 'reptichip' },
      { key: 'BabiChip',     match: 'babichip' },
      { key: 'ReptiEarth',   match: 'reptiearth' },
      { key: 'RediChip',     match: 'redichip' },
      { key: 'TropicalBase', match: 'tropicalbase' },
      { key: 'MicroChip',    match: 'microchip' }
    ];

    for (const { key, match } of patterns) {
      if (s.includes(match) && state.catalog.products[key]) return key;
    }

    for (const key of catalogKeys) {
      if (s.includes(key.toLowerCase())) return key;
    }

    return null;
  }

  function getRecommendedSubstrateKeysForCurrentSelection() {
    const animal = getCurrentAnimal();
    const ageLabel = state.selections.maturity;
    if (!animal || !ageLabel) return [];
    const ageKey = ageLabel.toString().trim().toLowerCase().replace('-', '_');
    const src = animal.age_substrates && animal.age_substrates[ageKey];
    if (!Array.isArray(src) || !src.length) return [];
    const out = [];
    src.forEach((entry) => {
      const key = productStringToCatalogKey(entry);
      if (key && !out.includes(key)) out.push(key);
    });
    dbg('getRecommendedSubstrateKeysForCurrentSelection:', {
      animal: animal.title,
      ageLabel,
      out
    });
    return out;
  }




async function buildFormatCards(container, product, formatsToShow) {
  container.innerHTML = '';

  const grid = el('div', { class: 'swz-swatchgrid swz-cardgrid' });
  container.appendChild(grid);

  const items = formatsToShow.map((fmtKey) => {
    const handle = fmtKey === 'Block' ? product.handle_block : product.handle_ready;
    return { fmtKey, handle };
  });

  const cards = await Promise.all(items.map(i => fetchProductCard(i.handle)));

  items.forEach((it, idx) => {
    const fmtKey = it.fmtKey;
    const p = cards[idx];
    const img = p?.image ? normalizeSrc(p.image) : null;

    const card = el('button', {
      type: 'button',
      class: 'swz-swatch swz-cardopt',
      dataset: { value: fmtKey } // IMPORTANT: click handler reads data-value
    });

    if (state.selections.format === fmtKey) card.classList.add('is-selected');

    card.innerHTML = `
      <div class="swz-cardopt__media">
        ${img ? `<img src="${img}" alt="${fmtKey}" loading="lazy">` : `<div class="swz-cardopt__ph"></div>`}
      </div>
      <div class="swz-cardopt__text">
        <div class="swz-cardopt__title">
           <div class="swzc-richtext"> 
             <p class="format-title">${fmtKey}</p>
            </div>
        </div>
      </div>
    `;

    grid.appendChild(card);
  });
}








  // ---------- build options per step

  async function buildOptionsForActiveStep() {
    const step = state.steps[state.currentIndex];
    if (!step) {
      dbg('buildOptionsForActiveStep: no step at index', state.currentIndex);
      return;
    }
    const key = step.key;
    const body = stepsMount.querySelector(`.swz-step__body[data-options-for="${key}"]`);
    if (!body) {
      dbg('buildOptionsForActiveStep: no body for key', key);
      return;
    }

    dbg('buildOptionsForActiveStep: step', key, 'selections', state.selections);

    if (key === 'broadCategory') {
      const cats = (state.taxonomy.categories || []).map((c) => c.name);
      buildSwatches(body, cats, key);

    } else if (key === 'specificAnimal') {
      buildAnimalCards(body);
      ensureStep2HelpMessage(body);

    } else if (key === 'maturity') {
      const allLabels = step.options || ['Juvenile', 'Sub-Adult', 'Adult'];
      const animal = getCurrentAnimal();

      if (animal && animal.age_substrates) {
        const nonEmptyLabels = allLabels.filter((label) => {
          const ageKey = label.toString().trim().toLowerCase().replace('-', '_');
          const arr = animal.age_substrates[ageKey];
          return Array.isArray(arr) && arr.length > 0;
        });

        if (nonEmptyLabels.length === 1) {
          const onlyLabel = nonEmptyLabels[0];
          state.selections.maturity = onlyLabel;

          // If user navigated BACK onto this step, don't bounce forward.
          if (state._navIntent === 'back') {
            state.autoSkipped.maturity = false;
            state.wasMaturityAutoSkipped = false;
            buildSwatches(body, [onlyLabel], key); // show single choice
            return;
          }

          state.wasMaturityAutoSkipped = true;
          state.autoSkipped.maturity = true;

          clearATC();
          state._skipHash = true;
          await showOnly(state.currentIndex + 1);
          state._skipHash = false;
          return;
        }


        state.autoSkipped.maturity = false;
        state.wasMaturityAutoSkipped = false;
        const labelsToShow = nonEmptyLabels.length ? nonEmptyLabels : allLabels;
        buildSwatches(body, labelsToShow, key);
      } else {
        state.autoSkipped.maturity = false;
        state.wasMaturityAutoSkipped = false;
        buildSwatches(body, allLabels, key);
    }

} else if (key === 'substrate') {

  const allProducts = Object.keys(state.catalog.products || {});
  let values = [];

  const ageKeys = getRecommendedSubstrateKeysForCurrentSelection();
  if (ageKeys.length) {
    values = ageKeys.filter((k) => allProducts.includes(k));
  } else {
    const catName = state.selections.broadCategory;
    const cat = findCategoryByName(catName);
    const defKey = cat && cat.defaults ? cat.defaults.substrate : null;

    if (defKey && allProducts.includes(defKey)) {
      values = [defKey];
    } else {
      values = allProducts;
    }
  }

    if (values.length === 1) {
      const only = values[0];
      state.selections.substrate = only;

      if (state._navIntent === 'back') {
        state.autoSkipped.substrate = false;
        buildSwatches(body, [only], key);
        return;
      }

      state.autoSkipped.substrate = true;

      clearATC();
      state._skipHash = true;
      await showOnly(state.currentIndex + 1);
      state._skipHash = false;
      return;
    }


  state.autoSkipped.substrate = false;
  buildSwatches(body, values, key);
  
  }else if (key === 'format') {

  const prodKey = state.selections.substrate;
  const product = (state.catalog.products || {})[prodKey] || {};
  const formats = product.formats ? Object.keys(product.formats) : [];

  // Only show formats that actually have a product handle
  const formatsToShow = formats.filter((f) => {
    if (f === 'Ready to Use') return !!product.handle_ready;
    if (f === 'Block') return !!product.handle_block;
    return false;
  });

  // ---- auto-skip if only one format exists
  if (formatsToShow.length === 1) {
    const only = formatsToShow[0];
    state.selections.format = only;

    if (state._navIntent === 'back') {
      state.autoSkipped.format = false;
      state.wasFormatAutoSkipped = false;
      await buildFormatCards(body, product, [only]);
      return;
    }

    dbg('format step: only one format, auto-selecting', only);

    state.wasFormatAutoSkipped = true;
    state.autoSkipped.format = true;
    delete state.selections.package;

    clearATC();
    state._skipHash = true;
    await showOnly(state.currentIndex + 1);
    state._skipHash = false;
    return;
  }

  // ---- normal render (two cards)
  state.autoSkipped.format = false;
  state.wasFormatAutoSkipped = false;

  await buildFormatCards(body, product, formatsToShow);

    } else if (key === 'package') {
      await buildPackageOptions(body).catch((err) => {
        console.error('[SWZ] buildPackageOptions error', err);
      });
    }
  }

  // ---------- package step: variant cards

  function resolveVariantId(prodKey, fmtKey, pkgName) {
    try {
      return (
        state.catalog.products[prodKey].formats[fmtKey].packages[pkgName].variant_id || null
      );
    } catch (_) {
      return null;
    }
  }

  async function buildPackageOptions(container) {
    const prodKey = state.selections.substrate;
    const fmtKey  = state.selections.format;
    const product = (state.catalog.products || {})[prodKey] || {};
    const fmt     = product.formats ? product.formats[fmtKey] : null;
    const packages = fmt?.packages ? Object.keys(fmt.packages) : [];

    const handle = fmtKey === 'Block' ? product.handle_block : product.handle_ready;

    dbg('buildPackageOptions:', { prodKey, fmtKey, packages, handle });

    setGlobalLoading(true);

    try {
      container.innerHTML = '';

      const items = packages.map((pkgName) => {
        const variant_id = resolveVariantId(prodKey, fmtKey, pkgName);
        return {
          pkgName,
          variant_id,
          promise: variant_id ? fetchVariant(variant_id, handle) : Promise.resolve(null)
        };
      });

      const results = await Promise.all(items.map((i) => i.promise));

      container.innerHTML = '';
      const grid = el('div', { class: 'swz-swatchgrid swz-cardgrid' });
      container.appendChild(grid);

      results.forEach((variant, idx) => {
        const { pkgName, variant_id } = items[idx];

        const card = el('button', {
          type: 'button',
          class: 'swz-swatch swz-cardopt',
          dataset: { value: pkgName, variantId: String(variant_id || ''), handle: handle || '' }
        });

        if (state.selections.package === pkgName) card.classList.add('is-selected');

        const title   = pkgName;
        const price   = variant ? fmtMoney(variant.priceCents, state.meta.currency) : 'Unavailable';
        const image   = variant?.image ? normalizeSrc(variant.image) : null;
        const soldOut = variant && variant.available === false;

        let perQuartLabel = '';
        if (variant) {
          const quarts = getQuarts(prodKey, fmtKey, pkgName);
          if (quarts) {
            perQuartLabel = buildPerQuartLabel(variant.priceCents, quarts);
          }
        }

        card.innerHTML = `
          <div class="swz-cardopt__media">
            ${image ? `<img src="${image}" alt="${title}" loading="lazy">` : `<div class="swz-cardopt__ph"></div>`}
            ${soldOut ? `<span class="swz-cardopt__badge">Sold out</span>` : ``}
          </div>
          <div class="swz-cardopt__text">
            <div class="swz-cardopt__title">${title}</div>
            <div class="swz-cardopt__price">${price}</div>
            ${perQuartLabel ? `<div class="swz-cardopt__priceper">${perQuartLabel}</div>` : ``}
          </div>
        `;

        if (!variant_id || soldOut) {
          card.disabled = true;
          card.classList.add('is-disabled');
        }

        grid.appendChild(card);
      });

      clearATC();
    } finally {
      setGlobalLoading(false);
    }
  }



// ---------- product fetch helper (for Format cards)

state.productCache = state.productCache || {};

async function fetchProductCard(handle) {
  if (!handle) return null;
  if (state.productCache[handle]) return state.productCache[handle];

  try {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;

    const pj = await res.json();

    const image = normalizeSrc(
      pj.featured_image || (Array.isArray(pj.images) ? pj.images[0] : null)
    );

    const payload = {
      handle,
      title: pj.title || handle,
      image
    };

    state.productCache[handle] = payload;
    return payload;
  } catch (e) {
    console.error('[SWZ] fetchProductCard error', e);
    return null;
  }
}


  // ---------- variant fetch helpers

  async function fetchVariant(variantId, handle) {
    if (!variantId) return null;
    if (state.variantCache[variantId]) return state.variantCache[variantId];

    dbg('fetchVariant: trying /variants', variantId);

    try {
      const res = await fetch(`/variants/${variantId}.json`);
      if (res.ok) {
        const js = await res.json();
        const v = js?.variant;
        if (v) {
          const payload = await normalizeVariantFromVariantJson(v);
          state.variantCache[variantId] = payload;
          return payload;
        }
      }
    } catch (err) {
      console.error('[SWZ] fetchVariant /variants error', err);
    }

    if (handle) {
      dbg('fetchVariant: fallback /products', handle);
      try {
        const pr = await fetch(`/products/${handle}.js`);
        if (pr.ok) {
          const pj = await pr.json();
          const v = (pj?.variants || []).find((x) => String(x.id) === String(variantId));
          if (v) {
            const payload = normalizeVariantFromProductJs(v, pj);
            state.variantCache[variantId] = payload;
            return payload;
          }
        }
      } catch (err) {
        console.error('[SWZ] fetchVariant /products error', err);
      }
    }

    return null;
  }

    async function normalizeVariantFromVariantJson(v) {
      const priceCents = toCents(v.price);
      let image = null;

      if (v?.featured_image) {
        image = normalizeSrc(v.featured_image.src || v.featured_image);
      }

      return {
        id: v.id,
        title: v.title,
        priceCents,
        sku: v.sku,
        image,
        available: !!v.available
      };
    }



    function normalizeVariantFromProductJs(v, productJs) {
      const priceCents = Number.isFinite(v.price) ? v.price : toCents(v.price);
      let image = normalizeSrc(v?.featured_image);
      if (!image) {
        const first = Array.isArray(productJs?.images) ? productJs.images[0] : null;
        image = normalizeSrc(first);
      }

      return {
        id: v.id,
        title: v.title,
        priceCents,
        sku: v.sku,
        image,
        available: !!v.available
      };
    }


  // ---------- ATC + broadcast

  async function renderATC() {
    const prodKey = state.selections.substrate;
    const fmtKey  = state.selections.format;
    const pkgName = state.selections.package;
    dbg('renderATC:', { prodKey, fmtKey, pkgName });
    if (!prodKey || !fmtKey || !pkgName) return;

    if (productSlot) {
      productSlot.innerHTML = '<div class="swz-inline-spinner swz-inline-spinner--center" aria-hidden="true"></div>';
    }
    if (addBtn) addBtn.disabled = true;
    setAddWrapVisible(true);

    const vid = resolveVariantId(prodKey, fmtKey, pkgName);
    if (!vid) {
      clearATC();
      showInlineError('We couldn’t load that size’s price. Please try again.');
      return;
    }

    const product = state.catalog.products[prodKey] || {};
    const handle =
      fmtKey === 'Block'
        ? product.handle_block
        : product.handle_ready;

    const variant = await fetchVariant(vid, handle);
    if (!variant) {
      clearATC();
      showInlineError('We couldn’t load that size’s price. Please try again.');
      return;
    }

    const quarts = getQuarts(prodKey, fmtKey, pkgName);
    const perQuartLabel = quarts ? buildPerQuartLabel(variant.priceCents, quarts) : '';

    productSlot.innerHTML = `
      <div class="swz-cardline">
        ${variant.image ? `<!--<img class="swz-thumb" src="${variant.image}" alt="${variant.title}" loading="lazy">-->` : ''}
        <div class="swz-lines">
          <!--<div class="swz-title">${variant.title || 'Selected variant'}</div>-->
          <div class="swz-sub">${prodKey} • ${fmtKey} • ${pkgName}</div>
          <div class="swz-price">${fmtMoney(variant.priceCents, state.meta.currency)}</div>
          ${perQuartLabel ? `<div class="swz-priceper">${perQuartLabel}</div>` : ``}
        </div>
      </div>
    `;

    const idInput = addForm && addForm.querySelector('input[name="id"]');


    if (idInput) idInput.value = vid;
    if (addBtn) addBtn.disabled = false;
    if (noteEl) noteEl.textContent = 'Ready to add to cart.';


    const becameReady = !state.atcReady;
    state.atcReady = true;

    if (becameReady) {
      track('swz_add_to_cart_shown', {
        journey_id: state.journey_id,
        variant_id: String(vid),
        product_key: prodKey,
        format: fmtKey,
        package: pkgName,
        price_cents: variant.priceCents,
        currency: state.meta.currency
      });
    }

    setAddWrapVisible(true);
  }

  function clearATC() {
    dbg('clearATC');
    setAddWrapVisible(false);
    state.atcReady = false;
    if (productSlot) productSlot.innerHTML = '';
    const idInput = addForm && addForm.querySelector('input[name="id"]');
    if (idInput) idInput.value = '';
    if (addBtn) addBtn.disabled = true;
    if (noteEl) noteEl.textContent = 'Complete the steps to enable Add to cart.';
  }

  function broadcast() {

renderBreadcrumbs();

    const stepKey = state.steps[state.currentIndex]?.key;
    const detail = {
      stepKey,
      stepIndex: state.currentIndex,
      option: state.selections[stepKey] ?? null,
      selections: { ...state.selections }
    };
    dbg('broadcast wizard:state', detail);
    window.__SWZ_STATE__ = detail;
    window.dispatchEvent(new CustomEvent('wizard:state', { detail }));
  }

  // ---------- interactions


  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSwzContactModal();
  });

  document.addEventListener('click', async (e) => {
    dbg('click event on stepsMount, target:', e.target);

    const crumbBtn = e.target.closest('[data-swz-crumb]');
    if (crumbBtn) {
      const idx = Number(crumbBtn.dataset.stepIndex);
      if (Number.isFinite(idx)) {
        clearATC();
        clearFromStepIndex(idx + 1);

        state._navIntent = 'back';
        await showOnly(idx);
        state._navIntent = null;
      }
      return;
    }

        // --- SWZ contact modal open/close
    const openContact = e.target.closest('[data-swz-open-contact]');
    if (openContact) {
      e.preventDefault();
      openSwzContactModal();
      return;
    }

    const closeContact = e.target.closest('[data-swz-close]');
    if (closeContact) {
      e.preventDefault();
      closeSwzContactModal();
      return;
    }




    const animalCard = e.target.closest('.swz-animalcard');
    if (animalCard) {
      const sec = e.target.closest('.swz-step');
      const key = sec?.dataset.stepKey;
      dbg('animalCard click', { key, value: animalCard.dataset.value });
      if (key !== 'specificAnimal') return;

      state.selections[key] = animalCard.dataset.value;

      track('swz_select', {
        journey_id: state.journey_id,
        step_key: 'specificAnimal',
        step_index: state.currentIndex,
        value: state.selections[key],
        method: 'click'
      });

      swzTrackAnimalSelection(state.selections[key]);

      state.autoSkipped[key] = false;
      clearATC();
      await showOnly(state.currentIndex + 1);
      return;
    }

    const swatch = e.target.closest('.swz-swatch');
    if (swatch) {
      const sec = e.target.closest('.swz-step');
      const key = sec?.dataset.stepKey;
      if (!key) {
        dbg('swatch click but no step key', { swatch });
        return;
      }

      const value = swatch.dataset.value;
      dbg('swatch click', { stepKey: key, value });

      qa('.swz-swatch.is-selected', sec).forEach((n) => n.classList.remove('is-selected'));
      swatch.classList.add('is-selected');

      state.selections[key] = value;
      state.autoSkipped[key] = false;

        track('swz_select', {
          step_key: key,
          step_index: Number(sec?.dataset.stepIndex || state.currentIndex),
          value: value,
          method: 'click'
        });
      


      const variantKeys = new Set(['substrate', 'format', 'package']);
      if (variantKeys.has(key)) {
        clearFromStepIndex(Number(sec.dataset.stepIndex) + 1);
      }


      if (key === 'package') {
        await renderATC();
      } else {
        clearATC();
        await showOnly(state.currentIndex + 1);
      }

      return;
    }

    if (e.target.closest('[data-action="back"]')) {
      const sec = e.target.closest('.swz-step');
      const key = sec?.dataset.stepKey;
      dbg('back button click from step', key, 'index', state.currentIndex);

      clearATC();

      const targetIdx = findPrevVisibleIndex(state.currentIndex - 1);

      // Clear selections AFTER the step we're going back to
      clearFromStepIndex(targetIdx + 1);

      // Tell autoskip logic we are navigating BACK (so don't auto-advance)
      state._navIntent = 'back';
      await showOnly(targetIdx);
      state._navIntent = null;

      return;
    }


  });

  stepsMount.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const sec = stepsMount.querySelector(`.swz-step[data-step-index="${state.currentIndex}"]`);
    const first = sec?.querySelector('.swz-swatch, .swz-animalcard');
    if (first && !sec?.querySelector('.is-selected')) {
      dbg('Enter key: auto-selecting first option');
      first.click();
    }
  });

  // ---------- quantity handlers

  function setQty(val) {
    if (!qtyInput) return;
    const min = Number(qtyInput.min) || 1;
    const max = qtyInput.max ? Number(qtyInput.max) : Infinity;

    let next = Number(val);
    if (!Number.isFinite(next)) next = min;
    if (next < min) next = min;
    if (next > max) next = max;

    qtyInput.value = String(next);
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', () => {
      setQty(qtyInput.value);
    });
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      const current = Number(qtyInput?.value || 1);
      setQty(current - 1);
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      const current = Number(qtyInput?.value || 1);
      setQty(current + 1);
    });
  }


  if (addForm) {
    addForm.addEventListener('submit', () => {
      const prodKey = state.selections.substrate || null;
      const fmtKey  = state.selections.format || null;
      const pkgName = state.selections.package || null;

      const idInput = addForm.querySelector('input[name="id"]');
      const vid = idInput?.value ? String(idInput.value) : null;

      const qty = Number(qtyInput?.value || 1);

      track('swz_add_to_cart', {
        variant_id: vid,
        quantity: Number.isFinite(qty) ? qty : 1,
        product_key: prodKey,
        format: fmtKey,
        package: pkgName,
        currency: state.meta.currency
      });
    });
  }




  // ---------- init

  (async function init() {
    try {
      const data = await loadAllJSONPages();
      state.meta     = data.meta || state.meta;
      state.steps    = data.steps || [];
      state.taxonomy = data.taxonomy || {};
      state.catalog  = data.catalog || { products: {} };
      state.animals  = data.animals || [];

      dbg('init: meta', state.meta);
      dbg('init: steps', state.steps);
      dbg('init: categories', (state.taxonomy.categories || []));
      dbg('init: animals count', state.animals.length);
      dbg('init: sample animals', state.animals.slice(0, 10).map(a => a.title));

      buildShell();
      clearATC();

      const initialKey = state.steps[0]?.key || '';
      toggleMainVisibilityFor(initialKey);

      await showOnly(0);

      // PAGE LOADER DONE → show wizard, hide loader
      if (pageLoader) pageLoader.style.display = 'none';
      if (container) container.style.display = '';

      track('swz_start', {
        journey_id: state.journey_id,
        page_path: location.pathname,
        page_url: location.href
      });


      dbg('init: complete');
    } catch (err) {
      console.error('[SWZ] init failed', err);

      // Even on error, don’t leave the loader stuck forever
      if (pageLoader) pageLoader.style.display = 'none';
      if (container) container.style.display = '';
    }

   const params = new URLSearchParams(location.search);
      if (params.get('contact_posted') === 'true') {
        swzShowContactSuccess();

        // Optional: clean URL so it doesn’t keep showing on refresh
        params.delete('contact_posted');
        const newUrl =
          location.pathname +
          (params.toString() ? `?${params.toString()}` : '') +
          location.hash;

        history.replaceState({}, '', newUrl);
      }

  })();

})();
